import TeamImage from "../../assets/ourTeam/01.png";
// import BannerImage from "../../assets/about us/pic1.png";
// import BannerImage from "../../assets/careerbanner.jpg";
import Image from "../../assets/careers/pic9.png";
import Image2 from "../../assets/careers/pic8.png";

import BannerImage from "../../assets/careers/pic2.png";
import pic3 from "../../assets/careers/pic3.png";
import image from "../../assets/careers/image.png";

import icon2 from "../../assets/careers/CAREER (1).png";
import icon4 from "../../assets/careers/CAREER (2).png";
import icon3 from "../../assets/careers/CAREER (3).png";
import icon1 from "../../assets/careers/CAREER.png";

import pic1 from "../../assets/careers/Life@Macworld/pic1.webp";
import pic2 from "../../assets/careers/Life@Macworld/pic2.webp";
import pic3_ from "../../assets/careers/Life@Macworld/pic3.webp";
import pic4 from "../../assets/careers/Life@Macworld/pic4.webp";
import pic5 from "../../assets/careers/Life@Macworld/pic5.webp";
import pic6 from "../../assets/careers/Life@Macworld/pic6.webp";
import infoSec1 from "../../assets/careers/informatioSection1.webp";
import infoSec2 from "../../assets/careers/informatioSection2.webp"
import DiversionAndInclusionImage1 from "../../assets/careers/diversityAndInclusion/img1.webp"
import DiversionAndInclusionImage2 from "../../assets/careers/diversityAndInclusion/img2.webp"
import DiversionAndInclusionImage3 from "../../assets/careers/diversityAndInclusion/img3.webp"

export const BannerData = {
  title: "About us",
  image: BannerImage,
  desc: "Mac World is a comprehensive logistical provider catering to small and large, commercial and non-commercial entities from almost any sector of Industry, In the UAE and around the world. We make our self available to customers 24/7, 365 days a year.",
};

export const WorkWithUsData = {
  title: "Our Story",
  img: pic3,
  Content1: `In the forwarding sector, our devoted in-house charter services are unmatched. We are known for accepting challenges that others deem too tough. The MAC World charter team operates globally around the clock and is always thinking outside the box to match your load with the appropriate aircraft. If your load needs to be moved by air, they will have the solution.`,
  items: [
    // { label: "We put people first", icon: icon1 },
    // { label: "We create the future", icon: icon2 },
    // { label: "We embrace change", icon: icon3 },
    // { label: "We offer good perks", icon: icon4 },
  ],
};
export const ourVision = {
  title: "Our Story",
  img: Image,
  Content1: `Our goal is to become our clients' go-to partner by assisting them in creating and maximizing long-term competitive advantages. We achieve this by assisting customers in bringing their goods to market in a timely, effective, and secure manner. Our clients can be guaranteed that every engagement will be guided by integrity and respect, the core values of our firm, in addition to our skillfully designed and consistently executed logistics solutions.`,
  items: [
    // { label: "We put people first", icon: icon1 },
    // { label: "We create the future", icon: icon2 },
    // { label: "We embrace change", icon: icon3 },
    // { label: "We offer good perks", icon: icon4 },
  ],
};

export const ourMission = {
  title: "Our Mission ",
  img: Image2,
  Content1: `Our goal is to provide every customer with a satisfying and dependable experience, while also providing outstanding value and raising the bar for professionalism in the logistic solutions we offer. Our mission is to provide a safe and secure work environment for our employees, so we endeavor to run our firm properly in addition to making a profit..`,
  items: [
    // { label: "We put people first", icon: icon1 },
    // { label: "We create the future", icon: icon2 },
    // { label: "We embrace change", icon: icon3 },
    // { label: "We offer good perks", icon: icon4 },
  ],
};

export const Content1Data = {
  title: "Our Vision",
  desc: `Our aim is to act as an indispensable partner to our clients by helping them build and maximize sustainable competitive advantages. We do this by helping them get their products to market quickly, efficiently, and safely. In addition to our expertly crafted and reliably delivered logistics solutions, our clients can rest assured that every interaction will be driven by integrity and respect, the fundamental principles of our business.`,
};
export const Content2Data = {
  title: "Our Mission",
  desc: `OOur goal is to provide every customer with a satisfying and dependable experience, while also providing outstanding value and raising the bar for professionalism in the logistic solutions we offer. Our mission is to provide a safe and secure work environment for our employees, so we endeavor to run our firm properly in addition to making a profit.`,
};

export const getToKnowData = [
  {
    title: "Business Intelligence",
    desc: "Introducing Cosimo, a passionate data enthusiast employed at Macworld Technology as a Business Intelligence Specialist. He is responsible for developing new analytical tools, improving current reports, and computing service level agreements.",
    img: pic1,
  },
  {
    title: "The Unseen Heroes of MWT",
    desc: "Uncovering the Hidden Heroes of MacWorld: Our Maintenance Staff: An amazing group that ensures our warehouses in Waalwijk and Tilburg work smoothly.",
    img: pic2,
  },
  {
    title: "Simplifying Daily Commutes",
    desc: "A dedicated bus route is set up between the warehouse and the closest commuter train station to facilitate employees' commutes to and from work.",
    img: pic3_,
  },
  {
    title: "MWT Logistics puts Work Safety first",
    desc: "Learn about the crucial role that safety officers play in logistics firms and about Astrid's many responsibilities at Macworld Logistics.",
    img: pic4,
  },
  {
    title: "Behind the Scenes at QESH: Talking to Morris and Mike",
    desc: "Discover more about Morris and Mike's roles as HSE Coordinators at Macworld Logistics and the obligations that come with holding such a significant position in the logistics industry.",
    img: pic5,
  },
  {
    title: "Process Optimizations with a hands-on Approach and analytical Structures",
    desc: "Being proactive is much appreciated. We're asking a lot of questions, exchanging fresh concepts, and always being able to provide one another fresh perspectives during team meetings.",
    img: pic6,
  }
];



export const InformationSectionData = [
  {
    heading: "People are key to our business",
    subHeading1:
      "After a hearty welcome and our comprehensive onboarding procedure, we provide frequent training to assist your personal growth. In addition to constantly developing our business and functional courses, we have excellent internal training programs. Worldwide management training is offered, with backing from our Learning Management System. We often hold feedback sessions with you throughout the year, focusing on your unique requirements and goals, as well as exploring new possibilities. Your feedback is extremely important to us. For MAC Wolrd, this means that your personal development is mirrored in our ongoing efforts to improve our business outcomes.",
    buttonText: "Find Us",
    image: infoSec1,
    imgFirst: true,
  
  },
  {
    heading: "We help you achieve the career success that you want",
    subHeading1:
      "We are aware that a contented, driven, and valued workforce is essential to our business's performance. And we make every effort to establish a fulfilling and stimulating atmosphere. One of our team members believes the following about her career at MacWorld: ",
    buttonText: "Find Us",
    image: infoSec2,
    imgFirst: false,
   
  },
  
];



export const diversityAndInclusionData = [
  {
    heading: "Equal opportunities for everyone",
    subHeading1:
      "With 110,000 workers from all over the world, MAC World Logistics is a sizable company that embraces diversity in terms of nationality, age, gender, sexual orientation, marital status, age, religion, and ethnicity. We acknowledge that individuals with varying experiences, backgrounds, and skill sets bring fresh insights and knowledge to our service offerings and business operations, fostering stronger bonds with our varied clientele.Our goal is to create a welcoming workplace where each individual is encouraged to realize their full potential and feels appreciated and cherished. We practice what we preach.",
    buttonText: "Find Us",
    image: DiversionAndInclusionImage1,
    imgFirst: true,
  
  }
];


export const diversityAndInclusionData2 = [
  {
    heading: "Iberia",
    subHeading1:
      "Initiatives for gender equality in Portugal and Spain (Iberia) include yearly celebrations of International Women's Day and International LGBT Pride Day, as well as workshops and online instruction on sexual harassment, equality, and work-life balance.In order to help MAC World become a more inclusive employer by better understanding disability challenges, disability equality initiatives include observing the International Day of Persons with Disabilities and collaborating with associations like Adisli, Down Espana, and Apsuria to hear about the experiences of affected individuals in the workplace.",
    buttonText: "Find Us",
    image: DiversionAndInclusionImage2,
    imgFirst: true,
  
  },
  {
    heading: "UNITED KINGDOM",
    subHeading1:"The gender pay gap has been recorded by Macworld Technology UK for the last three years, indicating a rise in the number of women in top posts. In an effort to draw more women into the field, it founded a Female Networking Group with Women in Logistics and backs the NOVUS initiative. Macworld Technologies has committed to treating service personnel and their families fairly and with respect as a signatory to the Armed Forces Covenant. The company encourages employment in logistics for young people and school dropouts, and it raises awareness in the community to support diversity in recruitment.",
    buttonText: "Find Us",
    image: DiversionAndInclusionImage3,
    imgFirst: false,
  
  },
  {
    heading: "NORTH AMERICA",
    subHeading1:"Black History Month, Remembrance Day (Canada), Veterans Day (USA), International Day of Families, Mother's Day, International Women's Day (Mexico, USA, and Canada), Children's Day (Mexico), and Wear Red Day are just a few of the occasions that MAC World Logsitics North America honors and promotes. A Veterans Placement Project headed by veterans of combat zones has been initiated by MAC World North America. After a few months of operation, three of the ten vets that were evaluated were recruited. Furthermore, MAC World North America is a supporter of Next Op, a nonprofit whose goal is to place veterans in full-time job.",
    buttonText: "Find Us",
    image: DiversionAndInclusionImage2,
    imgFirst: true,
  
  }
];